module.exports = __webpack_public_path__ + "static/media/smstocontrol1.2c3b49d8.png";